/* eslint-disable react/no-unstable-nested-components */
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import { Card } from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import { convertStringtoTitleCase } from '../../../Common/Utility/common-utils';
import {
  PACKAGE_URL,
  TELECONSULT_ROUTE,
  getPageType,
  getScreenName,
  ONE_ASTER_CATEGORY,
  PACKAGE_SERVICE_TYPE,
} from '../../../Common/Utility/constants';
import { PackageStyled } from './PackageStyled';
import { IC_SHARE_ICON, PACKAGE_CARD_DEFAULT } from '../../../Common/Assets/images';
import { sendSelectPackageEvent, sendShareEvent } from '../PackageAnalytics/packageAnalytics';
import Badge from '../ExclusivePackageBadge/Badge';
import useWindowDimensions from '../../../Common/Context/useWindowDimensions';
import ShareProduct from '../../../Epharmacy/ProductDetails/ShareProduct';
import { getFacilityId, getfacilityName } from '../../../Common/Utility/constants';
import { PAGE_NAME } from '@common/Constants/analytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const ExpiryBadge = dynamic(() => import('../OfferExpireBadge/ExpiryBadge'));
function Package({
  packages,
  packageId,
  packageName,
  packageImage,
  packageExpiryDate,
  totalServices,
  actulaPrice,
  savedPrice,
  isMyAsterExclusive,
  category,
  screenName,
  facilityName,
  facilityId,
  pageName,
  highlightKeyword,
  referrerPage,
  outerCustomClass,
  categoryName,
  headerPackageName,
  sectionName,
  packageCategory,
  packageCategoryName,
}) {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const ref = useRef();
  const windowSize = useWindowDimensions();
  const [clickOnShare, setClickOnShare] = useState(false);
  const shareUrl = `${window?.location?.origin}${generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}?referrerPage=Package+Listing`)}`;

  const BoldSuggestion = ({ children }) => <span className="highlight">{children}</span>;

  const movePackageDetails = (e) => {
    e.preventDefault();
    sendSelectPackageEvent(
      packages,
      getScreenName(screenName, categoryName, headerPackageName, facilityName),
      getPageType(pageName, screenName, categoryName),
      referrerPage,
      sectionName,
      String(packageId),
      getFacilityId(facilityId, packages?.isHomeSampleCollectionAllowed),
      getfacilityName(facilityName, packages?.isHomeSampleCollectionAllowed),
    );
    if (router?.query?.isFromFacility) {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          isFromFacility: router?.query?.isFromFacility,
          facilityName: router?.query?.facilityName,
          facilityId: router?.query?.facilityId,
          referrerPage: 'Clinic Detail',
        },
      });
    } else if (screenName === 'facility') {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          isFromFacility: true,
          facilityName,
          facilityId,
          referrerPage: 'Clinic Detail',
        },
      });
    } else if (screenName === 'Home Page' || screenName === 'Aster Core Home' || screenName === 'Tele Consult Home') {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          referrerPage: pageName,
        },
      });
    } else if (screenName === 'appointmentdetails') {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          referrerPage: pageName,
        },
      });
    } else if (packageCategoryName !== 'undefined' && screenName === 'packagedetails') {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          referrerPage: pageName,
          category: packageCategory,
          name: packageCategoryName,
        },
      });
    } else if (screenName === 'bookingConfirmation') {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          referrerPage: pageName,
        },
      });
    } else if (categoryName !== 'undefined' && screenName === 'package List') {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          referrerPage: 'Package Listing',
          category: category,
          name: categoryName,
        },
      });
    } else if (pageName === PAGE_NAME?.SRP) {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: {
          referrerPage: pageName,
        },
      });
    } else {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`),
        query: { referrerPage: 'Package Listing' },
      });
    }
  };

  React.useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (clickOnShare && ref.current && !ref.current.contains(e.target)) {
        setClickOnShare(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [clickOnShare]);

  return (
    <PackageStyled>
      <Card className={`packageCardWrapper cursor-pointer ${outerCustomClass}`}>
        <Card.Body className="packageCard">
          <a
            href={generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`)}
            onClick={(e) => {
              if (e.target.closest('.share-image-parent')) {
                e.preventDefault();
                return;
              }
              movePackageDetails(e);
            }}
          >
            <div className="packageDetailWrapper cursor-pointer">
              {isMyAsterExclusive && (
                <div className="badge-parent">
                  <Badge />
                </div>
              )}
              {screenName === 'package List' ? (
                <Image
                  className="packageImage"
                  src={packageImage || PACKAGE_CARD_DEFAULT.src}
                  alt="package"
                  height={windowSize?.width <= 480 ? 230 : 182}
                  width={windowSize?.width <= 480 ? 450 : 206}
                />
              ) : (
                <div className="imgWrapper">
                  <div className="img" data-test="div_1">
                    <Image
                      className="packageImage"
                      src={packageImage || PACKAGE_CARD_DEFAULT.src}
                      alt="package"
                      height="182"
                      width="153"
                      layout="fill"
                    />
                  </div>
                </div>
              )}
              <div className="share-product-parent" ref={ref}>
                <div
                  className="share-image-parent"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setClickOnShare(!clickOnShare);
                    sendShareEvent(
                      packages,
                      getScreenName(screenName, categoryName, headerPackageName, facilityName),
                      getPageType(pageName, screenName, categoryName),
                      referrerPage,
                      sectionName,
                    );
                  }}
                >
                  <Image src={IC_SHARE_ICON} alt="health package share" height={13.632} width={12.337} />
                </div>
                <div className="share-testing-image">
                  {clickOnShare && (
                    <ShareProduct
                      productName={packageName}
                      packageId={packageId}
                      shareUrl={shareUrl}
                      shareBy={' '}
                      productType={ONE_ASTER_CATEGORY.DOCTOR}
                      currency="AED"
                      value={actulaPrice}
                      serviceType={PACKAGE_SERVICE_TYPE}
                      screenName="Package Detail"
                      pageType="Package Details Page"
                    />
                  )}
                </div>
              </div>
              <div className="expiry-badge">
                <ExpiryBadge packageExpiryDate={packageExpiryDate} />{' '}
              </div>
              <div
                className={highlightKeyword ? 'packageName line-clamp mb-1 greyText' : 'packageName line-clamp mb-1'}
              >
                {highlightKeyword ? (
                  <Highlighter
                    highlightTag={BoldSuggestion}
                    highlightClassName="searchText"
                    searchWords={[highlightKeyword]}
                    autoEscape={true}
                    textToHighlight={packageName}
                  />
                ) : (
                  <div>{convertStringtoTitleCase(packageName)}</div>
                )}
              </div>
              <div className="packageServices" style={{ visibility: `${totalServices > 0 ? '' : 'hidden'}` }}>
                <div>
                  {totalServices} {totalServices > 1 ? 'Services included' : 'Service included'}
                </div>
              </div>
              {(windowSize.width > 480 || (windowSize.width < 480 && screenName !== 'package List')) && (
                <>
                  <div className="amountBlock">
                    <div className="packageAmount">
                      <span>AED {actulaPrice}</span>
                    </div>
                    <div className="packageSaveAmount">
                      {savedPrice !== null && savedPrice !== 0 && <span>Saves AED {savedPrice}</span>}
                    </div>
                  </div>
                  <div className="viewDetails">
                    <a
                      href={generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`)}
                      onClick={(e) => {
                        movePackageDetails(e);
                      }}
                    >
                      View Details
                    </a>
                  </div>
                </>
              )}
              {windowSize.width < 480 && screenName === 'package List' && (
                <div className="amountBlock-mobile">
                  <div className="packageAmount-mobile">
                    <span>AED {actulaPrice}</span>
                  </div>
                  <div className="packageSaveAmount-mobile">
                    {savedPrice !== null && savedPrice !== 0 && <span>Saves AED {savedPrice}</span>}
                  </div>
                  <div className="viewDetails">
                    <a
                      href={generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}/details/${packageId}`)}
                      onClick={(e) => {
                        movePackageDetails(e);
                      }}
                    >
                      View Details
                    </a>
                  </div>
                </div>
              )}
            </div>
          </a>
        </Card.Body>
      </Card>
    </PackageStyled>
  );
}

export default Package;
Package.propTypes = {
  packages: PropTypes.object,
  screenName: PropTypes.string,
  packageId: PropTypes.string,
  packageName: PropTypes.string,
  packageImage: PropTypes.string,
  packageExpiryDate: PropTypes.string,
  totalServices: PropTypes.string,
  actulaPrice: PropTypes.string,
  savedPrice: PropTypes.string,
  isMyAsterExclusive: PropTypes.bool,
  category: PropTypes.string,
  facilityName: PropTypes.string,
  facilityId: PropTypes.string,
  pageName: PropTypes.string,
  highlightKeyword: PropTypes.string,
  referrerPage: PropTypes.string,
  outerCustomClass: PropTypes.string,
  categoryName: PropTypes.string,
  headerPackageName: PropTypes.string,
  sectionName: PropTypes.string,
  packageCategory: PropTypes.string,
  packageCategoryName: PropTypes.string,
};
